import { ApiType } from "@gymflow/common";
import { zonedTimeToUtc } from "@gymflow/helpers";
import { useMutation } from "@tanstack/react-query";

export function useMemberCalculateProRataForResumingSubscription({
  api,
  tz,
}: {
  api: ApiType;
  tz: string;
}) {
  return useMutation({
    mutationFn: async ({
      memberId,
      subscriptionId,
      resumeDate,
    }: {
      memberId: string;
      subscriptionId: number;
      resumeDate: string;
    }) => {
      return (
        await api.memberApi.calculateProRata(
          memberId,
          subscriptionId,
          zonedTimeToUtc(resumeDate, tz),
        )
      ).data;
    },
  });
}
